export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dadata-organisation-autocomplete.vue?vue&type=template&id=4f0721d0&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/dadata-autocomplete/dadata-organisation-autocomplete.vue?vue&type=template&id=4f0721d0&
// module id = 979
// module chunks = 0